<template>
  <c_HuiFuMain
    :dh="state.dh"
    type="A_JSAPI"
    :key="state.dh"
    @onSubmit="onSubmit"
  ></c_HuiFuMain>
</template>

<script>
import { onMounted, reactive, onUnmounted } from "vue";
import { useRoute } from "vue-router";
import { huifu_createH5 } from "@/http/api";
export default {
  setup() {
    const route = useRoute();
    const state = reactive({});
    let redirectTimer = null;

    onMounted(() => {
      state.dh = route.query.dh;
    });

    onUnmounted(() => {
      // 组件卸载时清除定时器
      if (redirectTimer) {
        clearTimeout(redirectTimer);
      }
    });

    const onSubmit = (item) => {
      if (route.query.ph && route.query._t) {
        huifu_createH5("Zhb", item, route.query.ph, route.query._t)
          .then((res) => {
            if (res.status === 200) {
               window.location.href = res.data;
            }
          })
          .finally(() => {
            state.loading = false;
          });
      } 
    };
    return { state, onSubmit };
  },
};
</script>
<style scoped></style>
